export const getIncompleteQuestions = (selectedPhase, responses) => {
  if (!selectedPhase) return [];
  const incomplete = [];

  for (const focusArea of selectedPhase.focus_areas || []) {
    for (const q of focusArea.questions || []) {
      const response = responses.find((r) => r.question === q.id);
      let isComplete = false;

      if (!response?.answer || response.answer.trim() === '') isComplete = false;
      else if (response.answer === 'No') isComplete = true;
      else if (response.answer === 'Yes') {
        const hasEvidence = response.evidence && response.evidence.trim() !== '';
        const totalFiles = (response.backendFiles?.length || 0) + (response.newFiles?.length || 0);
        const hasFiles = totalFiles > 0;
        const hasFailedFiles = (response.newFiles || []).some((f) => f.status === 'failed');
        isComplete = hasEvidence && hasFiles && !hasFailedFiles;
      }

      if (!isComplete) {
        let reason = 'Answer required';

        if (response?.answer === 'Yes') {
          const hasEvidence = response.evidence && response.evidence.trim() !== '';
          const totalFiles = (response.backendFiles?.length || 0) + (response.newFiles?.length || 0);
          const hasFiles = totalFiles > 0;
          const hasFailedFiles = (response.newFiles || []).some((f) => f.status === 'failed');

          if (!hasEvidence && !hasFiles) reason = 'Missing evidence text and file';
          else if (!hasEvidence) reason = 'Missing evidence text';
          else if (!hasFiles) reason = 'Missing evidence file';
          else if (hasFailedFiles) reason = 'One or more file uploads failed';
        }

        incomplete.push({
          questionId: q.id,
          focusAreaTitle: focusArea.title,
          order: q.order,
          text: q.question_text || q.request,
          reason,
        });
      }
    }
  }

  return incomplete;
};

export const validateBeforeSubmit = (phaseResponses) => {
  if (!phaseResponses.length) return 'No questions found for this phase.';

  const hasPendingUploads = phaseResponses.some((r) =>
    (r.newFiles || []).some((f) => ['queued', 'uploading', 'failed'].includes(f.status))
  );
  if (hasPendingUploads) return 'Please resolve all pending/failed file uploads before submission.';

  for (const res of phaseResponses) {
    if (!res.answer || res.answer.trim() === '') return 'Please answer all questions before submitting.';
    if (res.answer === 'Yes') {
      if (!res.evidence || res.evidence.trim() === '') {
        return "Questions answered 'Yes' must include evidence text.";
      }
      const totalFiles = (res.backendFiles?.length || 0) + (res.newFiles?.length || 0);
      if (totalFiles === 0) return "Questions answered 'Yes' must include at least one evidence file.";
    }
  }

  return null;
};